export const SUPPORTED_LANGUAGES = {
  EN: 'en',
  PT_BR: 'pt_br'
};

export const LANGUAGE_LABELS = {
  [SUPPORTED_LANGUAGES.EN]: 'English',
  [SUPPORTED_LANGUAGES.PT_BR]: 'Português (BR)'
};

export const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES.EN;

// Currency to language mapping for auto-selection
export const CURRENCY_LANGUAGE_MAP = {
  BRL: SUPPORTED_LANGUAGES.PT_BR,
  USD: SUPPORTED_LANGUAGES.EN,
  EUR: SUPPORTED_LANGUAGES.EN,
  GBP: SUPPORTED_LANGUAGES.EN
};

export const LANGUAGE_STORAGE_KEY = 'checkout_language'; 

export const fieldConfig = {
  FIRST_NAME: { required: true },
  LAST_NAME: { required: true },
  EMAIL: { required: true },

  BILLING_FIRST_NAME: { required: true },
  BILLING_LAST_NAME: { required: true },
  BILLING_CITY: { required: true },
  BILLING_ADDRESS_LINE_1: { required: true },
  BILLING_ADDRESS_LINE_2: { required: true }, 
  BILLING_COUNTRY: { required: true },
  BILLING_ZIPCODE: { required: true },
  BILLING_STATE: { required: true },

  SHIPPING_FIRST_NAME: { required: true },
  SHIPPING_LAST_NAME: { required: true },
  SHIPPING_CITY: { required: true },
  SHIPPING_ADDRESS_LINE_1: { required: true },
  SHIPPING_ADDRESS_LINE_2: { required: true }, 
  SHIPPING_COUNTRY: { required: true },
  SHIPPING_ZIPCODE: { required: true },
  SHIPPING_STATE: { required: true },
};